const mutations = {
  mutationCommissionRequest(state, payload) {
    state.commissionRequest = payload;
  },

  mutationCommissionRequestList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.commissionRequestList[payload.tab] = payload.responseData;
    } else {
      state.commissionRequestList = payload;
    }
  },

  mutationCommissionRequestMeta(state, payload) {
    state.commissionRequestMeta = payload;
  },
};

export default mutations;
